import { scaleLinear } from 'd3-scale';
import { useMemo } from 'react';

import type { InspiredGlobalStudyPlatformApiModelsAxisCoordinate as AxisCoordinate } from 'applications/GSP/shared/api/gsp';
import type { ScaleLinear } from 'd3-scale';

const getDefaultYScale = (yScale: ScaleLinear<number, number, never>) =>
  yScale.ticks().map(y => `${y}%`);

export const useGetYAxe = (height: number, yAxis?: AxisCoordinate[]) => {
  const yScale = scaleLinear().range([height, 0]).domain([0, 100]);

  const yLabels = useMemo(() => {
    if (yAxis) {
      return yAxis.map(y => y.label);
    }

    return getDefaultYScale(yScale);
  }, [yAxis, yScale]);

  return {
    yScale,
    yLabels,
  };
};
